import { render, staticRenderFns } from "./CompanyInnovationCurve.vue?vue&type=template&id=21021682&scoped=true&"
import script from "./CompanyInnovationCurve.vue?vue&type=script&lang=js&"
export * from "./CompanyInnovationCurve.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInnovationCurve.vue?vue&type=style&index=0&id=21021682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21021682",
  null
  
)

export default component.exports